import { ZeroAddress } from 'ethers';
import useSWR from 'swr';
import { CONSTANTS } from '@/constants';
import { Chest__factory } from '@/contracts';
import { useWalletAddress } from '@/hooks/useWalletAddress';
import { sharedProvider } from '@/utils/share-provider';

// check user is smashed
async function fetchFreeChest({ address }: { address?: string }) {
  if (!address) {
    throw new Error('Not found Address');
  }

  const contract = Chest__factory.connect(
    CONSTANTS.SMASH_ADDRESS || '',
    sharedProvider.get(CONSTANTS.RPC),
  );
  const data = await contract.nextTimeToSmash(address);

  if (!data) {
    return {
      isOpenFreeChest: false,
      timestamp: Date.now(),
    };
  }
  return {
    isOpenFreeChest: Number(data) * 1000 >= Date.now(),
    timestamp: Number(data) * 1000,
  };
}

export function useFreeChest() {
  const address = useWalletAddress();

  const response = useSWR(
    { key: 'free-chest', address: address ?? ZeroAddress },
    fetchFreeChest,
  );

  return response;
}
